import React, { useState, useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TableCell, Stack } from "@mui/material";
import {
  Modal,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export const EditWearNatureModal = ({ editItem, onSave, onClose }) => {
  const [editedName, setEditedName] = useState(editItem.name || "");
  const [editedDescription, setEditedDescription] = useState(editItem.description || "");

  const handleSave = () => {
    const editedItem = {
      name: editedName,
      description: editedDescription,
    };
    onSave(editedItem, editItem._id);
    onClose();
  };
  return (
    <Modal
      open={!!editItem}
      onClose={onClose}>
      <Paper
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          p: 3,
        }}>
        <Typography
          variant="h5"
          sx={{ marginBottom: 2 }}>
          Edit Item
        </Typography>
        <TextField
          label="Name"
          fullWidth
          value={editedName || ""}
          onChange={(e) => setEditedName(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          label="Description"
          fullWidth
          value={editedDescription || ""}
          onChange={(e) => setEditedDescription(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{ flex: 1, marginRight: 1 }}>
            Save
          </Button>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ flex: 1, marginLeft: 1 }}>
            Close
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export const AddWearNatureModal = ({ addItem, onSave, onClose }) => {
  const [inputData, setInputData] = useState("");
  const handleChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const handleAddNew = () => {
    onSave(inputData);
    onClose();
  };
  return (
    <Modal
      open={!!addItem}
      onClose={onClose}>
      <Paper
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          p: 3,
        }}>
        <Typography
          variant="h5"
          sx={{ marginBottom: 2 }}>
          Add WearNature item
        </Typography>
        <TextField
          label="Name"
          name="name"
          fullWidth
          value={inputData.name}
          onChange={handleChange}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          label="Description"
          name="description"
          fullWidth
          value={inputData.description}
          onChange={handleChange}
          sx={{ marginBottom: 2 }}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            onClick={handleAddNew}
            sx={{ flex: 1, marginRight: 1 }}>
            Save
          </Button>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ flex: 1, marginLeft: 1 }}>
            Close
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export const DeleteConfirmationModel = ({ onOpen, onClose, confirmDelete, deletedItemId }) => {
  const handleDelete = () => {
    confirmDelete(deletedItemId);
    onClose();
  };
  return (
    <Dialog
      open={onOpen}
      onClose={onClose}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete this item? This action cannot be undone.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          variant="outlined"
          color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

/**
 * @param {*} param
 * @returns
 */

export const AdminFilter = ({ onOpen, onClose, onSubmit, disableButton, data }) => {
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedTerritory, setSelectedTerritory] = useState("");
  const handleChange = (event) => {
    const { name, value } = event.target;

    // Update the selected value based on the dropdown's name
    switch (name) {
      case "zone":
        setSelectedZone(value);
        setSelectedRegion("");
        setSelectedArea("");
        setSelectedTerritory("");
        break;
      case "region":
        setSelectedRegion(value);
        setSelectedArea("");
        setSelectedTerritory("");
        break;
      case "area":
        setSelectedArea(value);
        setSelectedTerritory("");
        break;
      case "territory":
        setSelectedTerritory(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = () => {
    const filter = {
      zone: selectedZone,
      region: selectedRegion,
      area: selectedArea,
      territory: selectedTerritory,
    };
    onSubmit(filter);
  };

  return (
    <div>
      <Dialog
        open={onOpen}
        onClose={onClose}>
        <DialogTitle>Select Field</DialogTitle>
        <div>
          <FormControl
            sx={{ m: 1, minWidth: 120 }}
            size="small">
            <InputLabel id="zone-label">Zone</InputLabel>
            <Select
              labelId="zone-label"
              value={selectedZone}
              name="zone"
              onChange={handleChange}
              label="Zone">
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {data?.map((item) => (
                <MenuItem
                  key={item.zone}
                  value={item.zone}>
                  {item.zone}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>Select Zone</FormHelperText>
          </FormControl>

          {selectedZone && (
            <FormControl
              sx={{ m: 1, minWidth: 120 }}
              size="small">
              <InputLabel id="region-label">Region</InputLabel>
              <Select
                labelId="region-label"
                value={selectedRegion}
                name="region"
                onChange={handleChange}
                label="Region">
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {data
                  ?.find((item) => item.zone === selectedZone)
                  .region?.map((regionItem) => (
                    <MenuItem
                      key={regionItem.regionCode}
                      value={regionItem.regionCode}>
                      {regionItem.regionCode}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText>Select Region</FormHelperText>
            </FormControl>
          )}

          {selectedRegion && (
            <FormControl
              sx={{ m: 1, minWidth: 120 }}
              size="small">
              <InputLabel id="area-label">Area</InputLabel>
              <Select
                labelId="area-label"
                value={selectedArea}
                name="area"
                onChange={handleChange}
                label="Area">
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {data
                  ?.find((item) => item.zone === selectedZone)
                  .region?.find((regionItem) => regionItem.regionCode === selectedRegion)
                  .area?.map((areaItem) => (
                    <MenuItem
                      key={areaItem.areaCode}
                      value={areaItem.areaCode}>
                      {areaItem.areaCode}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText>Select Area</FormHelperText>
            </FormControl>
          )}

          {selectedArea && (
            <FormControl
              sx={{ m: 1, minWidth: 120 }}
              size="small">
              <InputLabel id="territory-label">Territory</InputLabel>
              <Select
                labelId="territory-label"
                value={selectedTerritory}
                name="territory"
                onChange={handleChange}
                label="Territory">
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {data
                  ?.find((item) => item.zone === selectedZone)
                  .region?.find((regionItem) => regionItem.regionCode === selectedRegion)
                  .area?.find((areaItem) => areaItem.areaCode === selectedArea)
                  .territoryCode?.map((territoryItem) => (
                    <MenuItem
                      key={territoryItem}
                      value={territoryItem}>
                      {territoryItem}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText>Select Territory</FormHelperText>
            </FormControl>
          )}
        </div>
        <div>
          <Stack direction="row">
            <Button
              sx={{ m: 1, maxWidth: 200 }}
              variant="contained"
              color="success"
              onClick={handleSubmit}>
              Generated CSV
            </Button>
            <Button
              sx={{ m: 1, maxWidth: 200 }}
              variant="contained"
              color="error"
              onClick={onClose}>
              Cancel
            </Button>
          </Stack>
        </div>
      </Dialog>
    </div>
  );
};
